import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'app-popup-marker',
    templateUrl: './popup-marker.component.html'
})

export class PopupMarkerComponent implements OnInit {
    constructor(public activeModal: NgbActiveModal) {
    }

    videoId = '';
    body = '';
    title = '';
    titleClass = ''

    ngOnInit() {
    }
}
